import Vue from "vue";
import Vuex from "vuex";
import decode from "jwt-decode";
import router from "../router";
import axios from "axios";

Vue.use(Vuex);

var store = new Vuex.Store({
  state: {
    token: null,
    usuario: null,
    acciones: null,
    permisos: null,
    hasNotChangePassword: null,
    targetRoute: null,
  },
  getters: {
    getUsuario(state) {
      return state.usuario
    },
    getHasNotChangePassword(state) {
      return state.hasNotChangePassword
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setAcciones(state, acciones) {
      state.acciones = acciones;
    },
    setTargetRoute(state, route) {
      state.targetRoute = route;
    },
    setHasNotChangePassword(state, hasNotChangePassword) {
      state.hasNotChangePassword = hasNotChangePassword;
    },
    setPermisos(state, permisos){
      state.permisos = permisos
    }
  },
  actions: {
    guardarToken({ commit }, token) {
      localStorage.setItem("token", token);
      commit("setToken", token);
      commit("setUsuario", decode(token));
    },
    async autoLogin({ commit }) {
      let token = localStorage.getItem("token");
      if (token) {
        commit("setToken", token);
        commit("setUsuario", decode(token));
        if (this.state.usuario.rol == "Coordinador Cabina") {
          let turnoActivo = false;

          let header = { Authorization: "Bearer " + this.state.token };
          let configuracion = { headers: header };

          await axios
            .get(`api/HistorialOperadoresCabina/${this.state.usuario.idUsuario}/Activo`, configuracion)
            .then(res => turnoActivo = true)
            .catch(err => console.error(err))

          if (!turnoActivo && router.currentRoute.path !== "/FormularioFirma") {
            router.push({ name: "login", query: { auto: true } }).catch(() => { });
          }
        }

        let header = { Authorization: "Bearer " + token };
        let configuracion = { headers: header };

        await axios
          .get(`/api/Usuarios/HasNotChange?userId=${this.state.usuario.idUsuario}`, configuracion)
          .then((res) => {
            commit("setHasNotChangePassword", res.data);
          })
          .catch((err) => console.error(err));

        if (this.state.usuario.rol == "Operador Grua") {
          if (!this.state.targetRoute.includes("/Boleta")) {
            router.push({ name: "AsignarGrua" }).catch((err) => { });
          }
        }
      }
    },
    async salir({ commit }) {
      if (this.state.usuario) {
        let header = { Authorization: "Bearer " + this.state.token };
        let configuracion = { headers: header };

        if (this.state.usuario.rol == "Coordinador Cabina") {
          await axios
            .put(
              `api/HistorialOperadoresCabina/${this.state.usuario.idUsuario}`,
              {},
              configuracion
            )
            .then(() => { })
            .catch(err => console.error(err))
        }

        if (this.state.usuario.rol == "Inspector") {
          await axios
            .put(
              `api/HistorialInspectores/${this.state.usuario.idUsuario}`,
              {},
              configuracion
            )
            .then(() => { })
            .catch(err => console.error(err))
        }
      }

      commit("setToken", null);
      commit("setUsuario", null);
      localStorage.removeItem("token");
      localStorage.removeItem("tokenVanGrupo")
      router.push({ name: "login" }).catch(() => { });
    },
    guardarAcciones({ commit }, acciones) {
      commit("setAcciones", acciones);
    },
    guardarPermisos({commit}, permisos){
      commit("setPermisos", permisos);
    }
  },
});

export default store;